var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalFormOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_707_466)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 23.5C64.74 23.5 77.5 34.72 77.5 48.57C77.5 53.86 75.64 58.76 72.46 62.8V74.92L63.87 69.96C59.54 72.29 54.45 73.64 49 73.64C33.26 73.64 20.5 62.42 20.5 48.57C20.5 34.73 33.26 23.5 49 23.5Z",
    fill: "#FCF7C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.46 77.42C72.89 77.42 73.32 77.31 73.71 77.09C74.48 76.64 74.96 75.82 74.96 74.92V63.64C78.26 59.16 80 53.96 80 48.57C80 33.37 66.09 21 49 21C31.91 21 18 33.37 18 48.57C18 63.77 31.91 76.14 49 76.14C54.19 76.14 59.27 74.99 63.79 72.81L71.2 77.09C71.6 77.3 72.03 77.42 72.46 77.42ZM63.87 67.46C63.46 67.46 63.05 67.56 62.68 67.76C58.58 69.97 53.84 71.14 49 71.14C34.66 71.14 23 61.02 23 48.57C23 36.13 34.66 26 49 26C63.34 26 75 36.13 75 48.57C75 53.11 73.44 57.5 70.49 61.25C70.14 61.69 69.96 62.23 69.96 62.79V70.58L65.12 67.79C64.73 67.57 64.3 67.46 63.87 67.46Z",
    fill: "#186F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.46 77.42C73.84 77.42 74.96 76.3 74.96 74.92V63.64C78.26 59.16 80 53.96 80 48.57C80 33.37 66.09 21 49 21C47.62 21 46.5 22.12 46.5 23.5C46.5 24.88 47.62 26 49 26C63.34 26 75 36.12 75 48.57C75 53.11 73.44 57.5 70.49 61.25C70.14 61.69 69.96 62.23 69.96 62.79V74.91C69.96 76.3 71.08 77.42 72.46 77.42Z",
    fill: "#60ACD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.98 46.5H61.02C62.4 46.5 63.52 45.38 63.52 44C63.52 42.62 62.4 41.5 61.02 41.5H36.99C35.61 41.5 34.49 42.62 34.49 44C34.49 45.38 35.6 46.5 36.98 46.5Z",
    fill: "#FFA502"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.84 56.9199H61.02C62.4 56.9199 63.52 55.7999 63.52 54.4199C63.52 53.0399 62.4 51.9199 61.02 51.9199H45.84C44.46 51.9199 43.34 53.0399 43.34 54.4199C43.34 55.7999 44.46 56.9199 45.84 56.9199Z",
    fill: "#FFA502"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_707_466",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_707_466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_707_466",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalFormOpen);
export default __webpack_public_path__ + "static/media/ModalFormOpen.077eac6b1d20619d4cbfec7ff1026f04.svg";
export { ForwardRef as ReactComponent };